import { CKSelectableItem } from 'clearkit';

import { EnrichmentAttribute } from '~/generated/graphql';

import { FieldMapping, MappingProperty } from './types';
import { FieldMappingList, RecordType } from './useEnrichment/machineTypes';

export const clearbitType = (type: RecordType) =>
  type === 'company' ? 'company' : 'person';

export const isEmptyMapping = (fieldMapping: FieldMapping) => {
  return (
    !fieldMapping.dataType &&
    !fieldMapping.sourceField &&
    !fieldMapping.targetField
  );
};

export const filterEmptyMappings = (fieldMappings: FieldMappingList) => {
  return fieldMappings.filter((mapping) => !isEmptyMapping(mapping));
};

const isMasterEnrichmentEnabled = () => {
  /**
   * @todo replace this with the actual value from the API
   */
  // const {  } = state.context;

  return true;
};

export const isCompanyEnrichmentDisabled = (state: any, type: RecordType) => {
  const { companyPropertiesCount } = state.context;

  return (
    type === 'company' &&
    !isMasterEnrichmentEnabled() &&
    !companyPropertiesCount
  );
};

export const isContactEnrichmentDisabled = (state: any, type: RecordType) => {
  const { contactPropertiesCount } = state.context;

  return (
    type === 'contact' &&
    !isMasterEnrichmentEnabled() &&
    !contactPropertiesCount
  );
};

export const isLoading = (state: any) => {
  return (
    state.matches('loading') ||
    state.matches('loadingSchema') ||
    state.matches('loadingMappings')
  );
};

export const isDrawerVisible = (state: any) => {
  return (
    state.matches('confirmDisablingEnrichment') ||
    state.matches('disablingEnrichment') ||
    state.matches('editingMappings') ||
    state.matches('refreshingProperties') ||
    state.matches('savingMappings')
  );
};

export const isValidMapping = (mapping: FieldMapping) => {
  if (!mapping.sourceField && mapping.targetField) {
    return false;
  } else if (mapping.sourceField && !mapping.targetField) {
    return false;
  }

  return true;
};

export const lookupSelectableItem = (
  value: string,
  options: CKSelectableItem[],
) => {
  return options?.find((option) => option.value === value);
};

export const makeMappingProperty = (mapping: FieldMapping): MappingProperty => {
  return {
    clearbit: mapping.sourceField || '',
    hubspot: mapping.targetField || '',
  };
};

export const getFieldMetaData = (
  clearbitValue: string,
  clearbitAttributes: EnrichmentAttribute[],
) => {
  const attribute = clearbitAttributes?.find(
    (attribute) => attribute.value === clearbitValue,
  );

  return {
    sourceType: attribute?.meta.sourceType || '',
    dataType: attribute?.meta.dataType || '',
  };
};

export const getTransformedOptions = (
  recordType: RecordType,
  companyAttributes: EnrichmentAttribute[],
  personAttributes: EnrichmentAttribute[],
) => {
  return recordType === 'company'
    ? transformOptions(companyAttributes)
    : transformOptions(personAttributes);
};

export const pluralizeType = (type: RecordType) =>
  type === 'company' ? 'companies' : 'contacts';

export const transformOptions = (attributes: EnrichmentAttribute[]) => {
  const transformedOptions = attributes?.map((attribute) => {
    return {
      label: attribute.label,
      value: attribute.value,
    };
  });

  return transformedOptions;
};
